<template>
    <b-card
        no-body
        class="card-payment"
    >
        <b-card-header>
            <b-card-title>Filtro</b-card-title>
        </b-card-header>
        <b-card-body>
            <b-form>
                <b-row>
                    <b-col lg="3" md="6" sm="6">
                        <b-form-group
                            label="Nombre"
                            label-for="code"
                            class="mb-2"
                        >
                            <b-form-input
                                id="code"
                                v-model="search.installation_code"
                                type="text"
                                autocomplete="off"
                                @keyup="searchMasterInstallation()"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" sm="6">
                        <b-form-group
                            label="Cliente"
                            label-for="name"
                            class="mb-2"
                        >
                            <b-form-input
                                id="client"
                                v-model="search.client"
                                type="text"
                                autocomplete="off"
                                @keyup="searchMasterInstallation()"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col lg="3" md="6" sm="6">
                        <b-form-group
                            label="Empresa"
                            label-for="email"
                            class="mb-2"
                        >
                            <v-select
                                v-model="search.companies"
                                class="pt-0" label="name" name="name"
                                :reduce="(option) => option.id"
                                :options="companiesList"
                                multiple
                                @input="searchMasterInstallation()"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col lg="2" md="6" sm="6">
                        <b-form-group
                            label="Activa"
                            label-for="active"
                            class="mb-2"
                        >
                            <select v-model="search.active" class="custom-select" @change="searchMasterInstallation()">
                                <option value=""/>
                                <option v-for="status in boolean"
                                        :key="status.value"
                                        :value="status.value"> {{ status.name }}
                                </option>
                            </select>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-card-body>
    </b-card>
</template>

<script>
import { BCard, BCardHeader, BCardTitle, BCardBody, BRow, BCol, BFormGroup, BFormInput, BForm } from 'bootstrap-vue'
import {createHelpers} from "vuex-map-fields"
import {boolean} from "@/constants/constants"
import vSelect from "vue-select"


const {mapFields} = createHelpers({
    getterType: 'masterInstallation/getField',
    mutationType: 'masterInstallation/updateField',
})

export default {
    name: "SearchView",
    components: {
        vSelect,
        BCard,
        BCardHeader,
        BCardTitle,
        BCardBody,
        BRow,
        BCol,
        BForm,
        BFormGroup,
        BFormInput,
    },
    props: {
        // eslint-disable-next-line vue/require-default-prop
        clickSearch: {
            type: Function,
        }
    },
    data() {
        return {
            clients: [],
            states: [],
            companiesList: [],

            boolean
        }
    },
    computed: {
        ...mapFields({
            search: 'search',
        }),
    },
    mounted() {
        this.getCompanies()
    },
    methods: {
        searchMasterInstallation: function (){
            this.clickSearch()
        },
        getCompanies() {
          this.showLoading = true

          const userCompanies = this.$store.state.AppActiveUser.companies

          if (!userCompanies || userCompanies.length === 0) {
            // Si no hay compañías en AppActiveUser, se obtiene la lista completa
            this.$store.dispatch('companies/getAllCompanies')
                .then(response => {
                  this.companiesList = response
                })
                .catch(error => {
                  console.error("Error obteniendo compañías:", error)
                })
                .finally(() => {
                  this.showLoading = false
                })
          } else {
            // Si ya hay compañias en AppActiveUser, se usan esas
            this.companiesList = userCompanies.map(company => ({
              id: company.id,
              name: company.name
            }))
            this.showLoading = false
          }
        }
    }
}
</script>

<style scoped>

</style>